const BINANCE_INTERVAL_MAP = {
    "1m": "1m", "3m": "3m", "5m": "5m", "15m": "15m", "30m": "30m",
    "1h": "1h", "4h": "4h", "1D": "1d", "1W": "1w",
};
function normalizeTimeframe(tf) {
    return BINANCE_INTERVAL_MAP[tf] ?? tf;
}
export class BinanceStockDataAdapter {
    adapter;
    constructor(adapter) {
        this.adapter = adapter;
    }
    async fetchBarsInRange(symbol, timeframe, from, to) {
        const safeTf = normalizeTimeframe(timeframe);
        const safeTo = new Date(Math.min(to.getTime(), Date.now()));
        const bars = await this.adapter.fetchBarsInRange(symbol, safeTf, from, safeTo);
        return bars.map((b, i) => ({
            date: new Date(b.timestamp), open: b.open, high: b.high,
            low: b.low, close: b.close, volume: b.volume,
            index: i, dataIndex: i,
        }));
    }
    async fetchBarsBefore(symbol, timeframe, before, limit) {
        const safeTf = normalizeTimeframe(timeframe);
        const safeBefore = new Date(Math.min(before.getTime(), Date.now()));
        const bars = await this.adapter.fetchBarsBefore(symbol, safeTf, safeBefore, limit);
        return bars.map((b, i) => ({
            date: new Date(b.timestamp), open: b.open, high: b.high,
            low: b.low, close: b.close, volume: b.volume,
            index: i, dataIndex: i,
        }));
    }
    subscribeToBar(symbol, timeframe, onBar) {
        const safeTf = normalizeTimeframe(timeframe);
        const unsub = this.adapter.subscribeKline?.({
            symbol,
            interval: safeTf,
            callback: (bar) => {
                onBar({
                    date: new Date(bar.timestamp),
                    open: bar.open,
                    high: bar.high,
                    low: bar.low,
                    close: bar.close,
                    volume: bar.volume,
                    index: 0,
                    dataIndex: 0,
                });
            },
        });
        return unsub ?? (() => { });
    }
    subscribeToTrades() {
        return () => { };
    }
    subscribeToOrderbook() {
        return () => { };
    }
    async searchSymbols() {
        return [];
    }
    getSourceSemantics() {
        return {
            sourceId: "binance",
            sourceContractVersion: "binance-klines-v1",
            instrumentClass: "crypto",
            coverageMode: "exact-range",
            sessionModel: "continuous",
            timezone: "UTC",
            supportsExactRangeFetch: true,
            supportsBackwardAnchor: true,
            supportsForwardAnchor: false,
            supportsLiveBars: true,
            maxBarsPerRequest: 1000,
            finalityMode: "near-now-provisional",
            expectedGapReasons: [
                "not-fetched",
                "source-no-data",
                "rate-limited",
                "boundary-exhausted",
            ],
        };
    }
}
